// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__B3VSt","header":"ReportDetails_header__1fT1I","title":"ReportDetails_title__10zAd","left":"ReportDetails_left__VQvMA"};